import { useState, type FormEvent } from 'react'
import { Button } from '@/components/Button'
import { Field } from '@/components/Field'
import { setMemberName } from '@/data/household'
import { useAuth } from '@/store/auth'
import { firstName, setOnboarding, useHousehold } from '@/store/household'
import './Onboarding.css'

/** The second person, just joined, confirms the name shown on their cards. */
export function NameScreen() {
  const user = useAuth((s) => s.user)!
  const hid = useHousehold((s) => s.hid)!
  const household = useHousehold((s) => s.household)!
  const current = household.members[user.uid]?.name ?? firstName(user.displayName)
  const [name, setName] = useState(current)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const otherName = Object.entries(household.members).find(([uid]) => uid !== user.uid)?.[1].name

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (!name.trim()) {
      setError('Enter a name.')
      return
    }
    setBusy(true)
    try {
      if (name.trim() !== current) await setMemberName(hid, user.uid, name)
      setOnboarding('none')
    } catch (err) {
      setError((err as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="onboard">
      <header className="onboard__header">
        <p className="eyebrow">{household.name}</p>
        <h1 className="onboard__title">What should we call you?</h1>
        <p className="onboard__lead">
          {otherName ? `${otherName} added you. ` : ''}
          Your name shows on the tasks assigned to you. Cards use just the first letter.
        </p>
      </header>
      <form className="onboard__form" onSubmit={onSubmit}>
        <Field label="Your name" value={name} onChange={(e) => setName(e.target.value)} autoComplete="given-name" maxLength={40} required />
        {error && (
          <p className="onboard__error" role="alert">
            {error}
          </p>
        )}
        <Button type="submit" variant="primary" size="lg" block disabled={busy}>
          Continue
        </Button>
      </form>
    </main>
  )
}
